import jwt from "jsonwebtoken";
import React from "react";
import {Redirect, Route} from "react-router";
import {safeLocalStorage} from "./storage";

const PublicRoute = ({ component: Component, ...rest }) => {
  const token = safeLocalStorage.getItem("Token") || "";
  const defaulttheme = token ? jwt.decode(token)["default"] : "";
  return (
    <Route
      {...rest}
      render={(props) => {
        return !token ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: defaulttheme }} />
        );
      }}
    />
  );
};
export default PublicRoute;
